const BASE_URL = process.env.REACT_APP_BASE_URL;

// Fetch coaching feed entries for a user
export const fetchCoachingFeed =
  ({ userId, page = 0, limit = 10 }) =>
  async (dispatch, getState) => {
    try {
      const token = getState().token;
      const response = await fetch(
        `${BASE_URL}/coaching-feed/${userId}?page=${page}&limit=${limit}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (!response.ok) throw new Error("Failed to fetch coaching feed");

      const data = await response.json();

      // Dispatch the fetched data to the Redux store
      // dispatch(setCoachingFeed(data.data));

      return data;
    } catch (error) {
      console.error("Error fetching coaching feed:", error);
      return null;
    }
  };

// Create a new coaching feed entry
export const createCoachingFeed = (values) => async (dispatch, getState) => {
  try {
    const token = getState().token;

    const response = await fetch(`${BASE_URL}/coaching-feed`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(values),
    });

    if (!response.ok) throw new Error("Failed to create coaching feed");

    const newEntry = await response.json();

    return newEntry;
  } catch (error) {
    console.error("Error creating coaching feed:", error);
    return null;
  }
};

// Update an existing coaching feed entry
export const updateCoachingFeed =
  (id, values) => async (dispatch, getState) => {
    try {
      const token = getState().token;

      const response = await fetch(`${BASE_URL}/coaching-feed/${id}`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      });

      if (!response.ok) throw new Error("Failed to update coaching feed");

      const updated = await response.json();

      return updated;
    } catch (error) {
      console.error("Error updating coaching feed:", error);
      return null;
    }
  };

// Delete a coaching feed entry
export const deleteCoachingFeed =
  (id, userId) => async (dispatch, getState) => {
    try {
      const token = getState().token;

      const response = await fetch(`${BASE_URL}/coaching-feed/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) throw new Error("Failed to delete coaching feed");

      return true;
    } catch (error) {
      console.error("Error deleting coaching feed:", error);
      return false;
    }
  };
